import { BLLViewCariler } from './../../../providers/bll/bll-viewCariler';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, Searchbar } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';
import { CarieklePage } from '../../CariIslemleri/cariekle/cariekle';


@Component({
  selector: 'page-carisec',
  templateUrl: 'carisec.html',
})
export class CarisecPage {
  aranan = "";
  skip: number = 0;
  take: number = 50;
  cariListesi = [];
  CariID:string;
 
  
  @ViewChild('searchbar') searchbar: Searchbar;
  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
     public navParams: NavParams,
     public viewCtrl:ViewController,
     public ortak:Ortak,
     public modalCtrl:ModalController) {

  }

  ionViewDidLoad() {
    this.OnlinecariAra();
    // this.girismesaji();

   
  }
  ionViewDidEnter() {
    setTimeout(() => {
      this.searchbar.setFocus();
    });
  }

  girismesaji()
  {
    this.ortak.showBasicAlert("Uyarı","Lütfen Mal Aldığınız Firmayı veya Cari'yi Seçiniz..");
  }
  OnlinecariAra() {
    var formData = new FormData();
    // formData.append("aranan", this.aranan);
    // formData.append("skip", this.skip.toString());
    // formData.append("take", "");
    // formData.append("grupkodu", "-1");
    formData.append("aranan", this.aranan);
    formData.append("skip", "0");
    formData.append("take", "1000");
    this.bllOrtak.islem(formData, "MusteriSec", "", false).then(a => {
      var sonuc = <any>a;
      this.cariListesi = sonuc.SonucObject;
      this.searchbar.setFocus();
    })
  }
  OfflineCariAra()
  {
    var cariler=new BLLViewCariler();
    cariler.getAll().then(a=>{
      var sonuc=<any>a;
      this.cariListesi=sonuc;
      if(this.cariListesi.length==0)
      {
        this.OnlinecariAra();
      }
    })
  }
  urunler(e) {

    if(this.aranan.length>2)
    {
      this.OnlinecariAra();

    }
    if(this.aranan.length==0)
    {
      this.OnlinecariAra();
    }
  
  }

  yeni()
  {
    let modal = this.modalCtrl.create(CarieklePage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });

    modal.present();
  }
  CariSec(aktarilacakCariKart) {
    this.viewCtrl.dismiss(aktarilacakCariKart);
 }
 kapat()
 {
   this.viewCtrl.dismiss();
 }
}



// WEBPACK FOOTER //
// ./src/pages/faturaislemleri/carisec/carisec.ts